import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../../pages/base-error";

@Component({
  selector: "sfl-item",
  templateUrl: "./sfl-item.component.html",
})
export class SflItemComponent extends BaseError {

  @Input() public item: any;
  public opened: boolean = false;

  constructor(
    public translate: TranslateService,
    public toastr: ToastrService,
  ) {
    super(toastr);
  }

  public showFormattedMoustach(): boolean {
    return this.item && this.item.type &&
      (this.item.type.toLowerCase() === "date" ||
      this.item.type.toLowerCase() === "day" ||
      this.item.type.toLowerCase() === "time" ||
      this.item.type.toLowerCase() === "number" ||
      this.item.type.toLowerCase() === "datetime");
  }

  public copyToClipboard(m, formatted: boolean = false) {
    console.log(m);
    let clipboardValue = `data.${m.key}`;
    if (m.type && (m.type.toLowerCase() === "catalog" || m.type.toLowerCase() === "classification") || m.type.toLowerCase() === "subcatalog") {
      clipboardValue += ".value";
    }
    navigator.clipboard.writeText(`{{${clipboardValue}${formatted ? " | formatted" : ""}}}`).then((e) => {
      this.responseSuccessful(`{{${clipboardValue}${formatted ? " | formatted" : ""}}} added to clipboard`);
    }, (e) => {
      this.showErrorMessage("Error!");
    });
  }

}
